<ng-container *ngIf="!viewMode; else viewPDF">
  <div>
    Save In:<br>
    {{ document?.propertiesObj?.FoldersFiledIn }}
  </div>
  <img *ngIf="!thumbnailWait || !document?.id; else loading" #thumbnailImg class="preview" (error)="thumbnailError()"
    [src]="filenetURL + '/getDocumentThumbnail?objectStoreName='+objectStore+'&documentID='+document?.id">

  <ng-template #loading>
    <mat-spinner></mat-spinner>
  </ng-template>


  <div>Number of Downloads: {{views}}</div>
  <div class="buttons">
    <a mat-raised-button color="primary" (click)="increaseDL()" mat-button
      [href]="filenetURL + '/getDocumentContent?objectStoreName='+objectStore+'&documentID='+document?.id">Download</a>
    <a *ngIf="document?.propertiesObj
  ?.MimeType === 'application/pdf'" mat-raised-button color="primary" (click)="goToViewMode()" mat-button>View</a>
  </div>
</ng-container>

<ng-template #viewPDF>
  <a mat-raised-button color="primary" (click)="viewMode = false">Back</a>
  <pdf-viewer class="preview"
    [src]="filenetURL + '/getDocumentContent?objectStoreName='+objectStore+'&documentID='+document?.id"
    [render-text]="true" style="display: block;" [show-all]="showAll"></pdf-viewer>
</ng-template>
